import React from "react";
import { Route, Switch } from "react-router-dom";

import { OAUTH_CALLBACK_PATH } from "lib/constants";
import { useUserSession } from "lib/hooks/useUserSession";

// avoid starting a user session when doing oauth callback because we could be in a temporary popup
export const UserSession: React.FC = () => {
  return (
    <Switch>
      <Route path={OAUTH_CALLBACK_PATH} exact={true} />
      <Route path="*">
        <StartUserSession />
      </Route>
    </Switch>
  );
};

const StartUserSession: React.FC = () => {
  useUserSession();
  return null;
};
